import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const TextField = (props: any) => {
  const {
    placeholder,
    value,
    register,
    type = "text",
    errors,
    label,
    disable = false,
  } = props;
  return (
    <>
      <div className={tw`w-full my-2 text-left mt-2`}>
        <label htmlFor="">{label}</label>
        <input
          placeholder={placeholder}
          autoComplete="off"
          disabled={disable}
          defaultValue={value}
          {...register}
          type={type}
          className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
        />
        {errors && (
          <p className={tw`text-red-500 text-xs my-1`}>{errors?.message}</p>
        )}
      </div>
    </>
  );
};

export default TextField;
